import React, { Component } from 'react';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import CloseIcon from '@material-ui/icons/Close';
import ActionButton from '../../../components/ActionButton';
import {
  Button,
  Checkbox,
  IconButton,
  MenuItem,
  Select,
  TextField,
} from '@material-ui/core';
import { getReparti, updateReparti } from '../../../utils/api/reparti';
import ModalResponsabiliPerReparto from '../manualecomponents/paragrafo4/ModalResponsabiliPerReparto';
import {
  ArrowDownward,
  ArrowUpward,
  Edit,
  KeyboardArrowUp,
  Done,
  Add,
  DeleteForever,
  PersonAdd,
  Build,
} from '@material-ui/icons';
import { getResponsabiliSicurezzaPerEsercizioDatoManualeId } from '../../../utils/api/responsabili_sicurezza_api';
import {
  getContenutoParagrafo,
  updateSottoparagrafi,
} from '../../../utils/api/paragrafi_api';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import {
  getLocaliManuale,
  getTotaleLocali,
  updateLocaliManuale,
} from '../../../utils/api/locali_e_attrezzature_api';
import ModalSelezioneAttrezzatura from './ModalSelezioneAttrezzatura';
import ModalSelezioneModalitaAutocontrollo from './ModalSelezioneModalitaAutocontrollo';
import GoToIcon from './GoToIcon';
import DialogConfirmOperation from '../components/DialogConfirmOperation';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
  },
  topButtonWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
    margin: '10px 0',
  },
});

class CustomTableForManuale extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      records: [],
      reparti: [],
      isBlocked: this.props.isParagrafoBlocked,
      isModello: true,
      selectedReparto: null,
      responsabiliSicurezza: [],
      sottoParagrafiDataAfterSave: this.props.sottoParagrafiData,
      selectProcedureAutocontrolloModalOpen: false,
      titoloInizialeSottoparagrafo: this.props.titoloInizialeSottoparagrafo,
      firstElement: null,
      openModalResponsabili: false,
      selectedLocale: null,
      openModalAttrezzatura: false,
      indexTab: this.props.indexTab,
      isTitleEditable: false,
      totalPages: 0,
      title: this.props.titolo,
      rowWidth: 0,
      editMode: false,
      dataToPassForProcedure: this.props.sottoParagrafiData,
      mode: '',
      firstRender: true,
      id: 0,
      indexSelectedReparto: 0,
      aggiuntaButtonDisabler: false,
      confirmRemoveLocale: {
        open: false,
        rowIndex: null,
      },
      confirmRemoveReparto: { open: false, rowIndex: null },
      confirmRemoveProcedura: { open: false, rowIndex: null },
      deletingReparto: false,
      deletingLocale: false,
      deletingProcedura: false,
      tableKey: 0,
    };
  }

  swapElements = (arr, i1, i2) => {
    let temp = arr[i1];

    arr[i1] = arr[i2];

    arr[i2] = temp;
  };

  swapElementsLocali = (arr, i1, i2) => {
    let temp = arr[i1];
    let tempIndice = arr[i1].indiceOrdinamento;
    let tempIndice2 = arr[i2].indiceOrdinamento;
    arr[i1] = arr[i2];
    arr[i2] = temp;
    arr[i2].indiceOrdinamento = tempIndice;
    arr[i1].indiceOrdinamento = tempIndice2;
  };

  getResponsabiliMailFromId = (ids) => {
    let responsabili = [...this.state.responsabiliSicurezza];
    const mails = responsabili
      .filter((responsabile) => ids.includes(responsabile.id))
      .map((responsabile) => responsabile.email)
      .join(' , ');

    return mails;
  };

  moveElementUpwardLocali = (cellInfo) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      let array = [...this.state.records];
      if (cellInfo.index > 0) {
        this.swapElementsLocali(array, cellInfo.index, cellInfo.index - 1);
        this.setState(
          {
            records: array,
          },
          () => {
            this.aggiornaLocali();
          },
        );
      }
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  moveElementUpwardOrganigramma = (cellInfo) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      let array = [...this.state.records];
      if (cellInfo.index > 0) {
        this.swapElements(array, cellInfo.index, cellInfo.index - 1);
        this.setState(
          {
            records: array,
          },
          () => {
            this.aggiornaOrganigrammaAfterInput();
          },
        );
      }
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  moveElementUpwardAutocontrolli = (cellInfo) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      let array = [...this.state.records];
      let sottoparagrafiArray = [...this.state.dataToPassForProcedure];
      let logicalArray = sottoparagrafiArray[1].componenti;
      if (cellInfo.index > 0) {
        this.swapElements(array, cellInfo.index, cellInfo.index - 1);
        this.swapElements(logicalArray, cellInfo.index, cellInfo.index - 1);
        sottoparagrafiArray.componenti = logicalArray;
        this.setState(
          {
            records: array,
            dataToPassForProcedure: sottoparagrafiArray,
          },
          () => {
            this.props.bringDataAfterExchange(
              sottoparagrafiArray.componenti,
              this.state.indexTab,
            );
          },
        );
      }
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  moveElementDownWardAutocontrolli = (cellInfo) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      let array = [...this.state.records];
      let sottoparagrafiArray = [...this.state.dataToPassForProcedure];
      let logicalArray = sottoparagrafiArray[1].componenti;
      if (cellInfo.index < array.length - 1) {
        this.swapElements(array, cellInfo.index, cellInfo.index + 1);
        this.swapElements(logicalArray, cellInfo.index, cellInfo.index + 1);
        sottoparagrafiArray.componenti = logicalArray;
        this.setState(
          {
            records: array,
            dataToPassForProcedure: sottoparagrafiArray,
          },
          () => {
            this.props.bringDataAfterExchange(
              sottoparagrafiArray.componenti,
              this.state.indexTab,
            );
          },
        );
      }
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  moveElementDownWardLocali = (cellInfo) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      let array = [...this.state.records];
      if (cellInfo.index < array.length - 1) {
        this.swapElementsLocali(array, cellInfo.index, cellInfo.index + 1);
        this.setState(
          {
            records: array,
          },
          () => {
            this.aggiornaLocali();
          },
        );
      }
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  moveElementDownWardOrganigramma = (cellInfo) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      let array = [...this.state.records];
      if (cellInfo.index < array.length - 1) {
        this.swapElements(array, cellInfo.index, cellInfo.index + 1);
        this.setState(
          {
            records: array,
          },
          () => {
            this.aggiornaOrganigrammaAfterInput();
          },
        );
      }
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  onAssociaButtonClicked = (reparto, index) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      this.setState({
        openModalResponsabili: true,
        selectedReparto: reparto,
        indexSelectedReparto: index,
      });
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  onCloseModalResponsabili = () => {
    this.setState({
      openModalResponsabili: false,
    });
  };

  onCloseModalSelezioneModalitaAutocontrollo = () => {
    this.setState({
      selectProcedureAutocontrolloModalOpen: false,
    });
  };

  onAttrezzaturaButtonClicked = (locale) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      this.setState({
        openModalAttrezzatura: true,
        selectedLocale: locale,
      });
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  onCloseModalAttrezzatura = () => {
    this.setState({
      openModalAttrezzatura: false,
    });
  };

  getNomeRepartoFromId = (array, id) => {
    for (let i = 0; i < array.length; i++) {
      let record = array[i];
      if (record.id === id) {
        return record.nome;
      }
    }
  };

  fetchResponsabiliSicurezza = (manualeInCostruzioneId) => {
    getResponsabiliSicurezzaPerEsercizioDatoManualeId(manualeInCostruzioneId)
      .then((result) => {
        this.setState({
          responsabiliSicurezza: result,
          //loading: false,
          //initialLoading: false
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  onResponsabiliSelected = (responsabiliIds) => {
    let reparti = this.state.records;
    if (reparti !== undefined) {
      reparti[this.state.indexSelectedReparto].responsabili = responsabiliIds;
      updateReparti(this.props.idManuale, reparti)
        .then((result) => {
          this.getRepartiData();
          this.props.aggiornaRepartiForResponsabili(reparti);
          this.onCloseModalResponsabili();
        })
        .catch((error) => {
          reportApiError(error);
        });
    } else {
      alert('Attenzione, selezionare almeno un consulente');
    }
  };

  aggiornaLocali = () => {
    let arrayToPass = [...this.state.records];
    this.props.aggiornaLocali(arrayToPass);
  };

  aggiungiDefinizioneProcedureAutocontrollo = (body) => {
    let dataToPass = this.state.dataToPassForProcedure;
    dataToPass[1].componenti.push(body);
    let bodyToPassForSottoparagrafi = {
      id: this.props.idParagrafo,
      manualeId: this.props.idManuale,
      titolo: 'Definizione procedure autocontrollo',
      componenti: dataToPass,
    };
    updateSottoparagrafi(bodyToPassForSottoparagrafi)
      .then((result) => {
        this.getSchedeHCCP();
        this.props.bringDataToParent(
          bodyToPassForSottoparagrafi,
          this.state.indexTab,
        );
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  handleCustomTableRow = (item) => {
    if (
      !this.state.isBlocked ||
      localStorage.getItem('superconsulente') === 'true' ||
      localStorage.getItem('consulenteId') === 'null'
    ) {
      let array = [...this.state.records];
      array.splice(item._index, 1);
      this.setState(
        {
          records: array,
          tableKey: this.state.tableKey + 1,
        },
        () => {
          this.aggiornaTabellaCustomHandler();
        },
      );
    } else {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
    }
  };

  aggiornaTabellaCustomHandler = () => {
    let array = [...this.state.records];
    let arrayOfValues = [];
    array.forEach((item) => {
      delete item['Elimina'];
      arrayOfValues.push(Object.values(item));
    });
    let sottoParagrafiToPass = [...this.state.sottoParagrafiDataAfterSave];

    sottoParagrafiToPass[this.props.indexTab].componenti[0].contenuto =
      JSON.stringify(arrayOfValues);
    sottoParagrafiToPass[this.props.indexTab].componenti[0].titolo =
      this.state.titoloInizialeSottoparagrafo;
    this.props.updateCustomTable(sottoParagrafiToPass);
    // Forza il rerender del solo ReactTable
    // this.setState((prevState) => ({ tableKey: prevState.tableKey + 1 }));
  };

  aggiornaOrganigrammaAfterInput = () => {
    let array = [...this.state.records];
    let arrayToPass = [];
    array.forEach((item) => {
      let objectArray = [];
      objectArray.push(item.NomeECognome);
      objectArray.push(item.Ruolo);
      objectArray.push(item.Mansione);
      objectArray.push(item.Identificativo);
      arrayToPass.push(objectArray);
    });
    let dataToPass = [...this.props.sottoParagrafiData];

    let objToPassToSave = {
      columns: ['Nome e cognome', 'Ruolo', 'Mansione', 'Identificativo'],
      rows: arrayToPass,
    };
    dataToPass.forEach((item) => {
      if (item.componenti[0].organigramma) {
        item.componenti[0].contenuto = JSON.stringify(objToPassToSave);
      }
    });

    this.props.changeEditMode();
  };

  componentDidMount = () => {
    this.initializeTable();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.isParagrafoBlocked !== this.props.isParagrafoBlocked) {
      this.setState({ isBlocked: this.props.isParagrafoBlocked });
    }
    if (this.props.mode !== this.state.mode) {
      this.initializeTable();
    }
    if (prevProps.columns !== this.props.columns) {
      this.initializeTable();
    }
    if (
      this.props.titoloInizialeSottoparagrafo !==
      prevProps.titoloInizialeSottoparagrafo
    ) {
      this.setState({
        titoloInizialeSottoparagrafo: this.props.titoloInizialeSottoparagrafo,
        sottoParagrafiDataAfterSave: this.props.sottoParagrafiData,
      });
      if (this.props.mode === 'Definizione_Reparto') {
        getReparti(this.props.idManuale, 0, 100, 'id')
          .then((result) => {
            let arrayToSave = [];
            result.forEach((item) => {
              let arrayResponsabiliToSave = [];
              item.responsabili.forEach((ids) => {
                arrayResponsabiliToSave.push(ids.id);
              });
              arrayToSave.push({
                id: item.id,
                manualeId: item.manualeId,
                nome: item.nome,
                repartoDefault: item.repartoDefault,
                responsabileSicurezzaId: item.responsabileSicurezzaId,
                responsabileSicurezzaEmail: item.responsabileSicurezzaEmail,
                responsabileSicurezzaNome: item.responsabileSicurezzaNome,
                responsabileSicurezzaCognome: item.responsabileSicurezzaCognome,
                responsabili: arrayResponsabiliToSave,
              });
            });
            this.setState({
              records: arrayToSave,
              selectedReparto: result[0],
              firstElement: result[0],
              firstRender: false,
            });
          })
          .then((result) => {
            this.fetchResponsabiliSicurezza(this.props.idManuale);
          })
          .catch((error) => {
            reportApiError(error);
          });
      }
    }
  };

  initializeTable = () => {
    let a = null;
    this.setState({
      mode: this.props.mode,
    });
    if (this.props.kind === 'modello') {
      this.setState({
        isModello: true,
      });
    } else {
      this.setState({
        isModello: false,
      });
    }
    if (this.props.mode === 'Organigramma') {
      a = this.getColumnsForOrganigramma();
    } else if (this.props.mode === 'Definizione_Reparto') {
      a = this.getColumnsForDefinizioneReparto();
    } else if (this.props.mode === 'Descrizione_Reparto') {
      a = this.getColumnsForDescrizioneReparti();
    } else if (this.props.mode === 'Definizione_Procedure_Autocontrollo') {
      a = this.getColumnsForElencoProcedureAutocontrollo();
    } else {
      a = this.getColumns();
    }
    this.setState({
      columns: a,
    });
    this.setState({
      rowWidth: 100 / this.state.columns.length,
    });
  };

  getColumns = () => {
    let passedColumns = this.props.columns;
    let content = this.props.contenuto;
    if (content !== undefined) {
      let contentToSave = JSON.parse(content);
      let recordsToSave = [];
      // `passedColumns` arrives in two shapes: {header, id} objects and
      // plain strings (the latter handled by the passedColumns[0].header
      // check below). item.id resolves here because only the
      // TABELLA_PERSONALIZZATA branch of CreazioneNuovoManuale passes
      // `contenuto`, and it always pairs it with object columns. The
      // string shape reaches us without `contenuto`, so it never enters
      // this loop.
      contentToSave.forEach((_item2, index2) => {
        let objectToSaveInArray = {};
        passedColumns.forEach((item, index) => {
          objectToSaveInArray[item.id] = contentToSave[index2][index];
        });
        recordsToSave.push(objectToSaveInArray);
      });
      this.setState({
        records: recordsToSave,
      });
    }
    let generatedColumns = [];
    if (passedColumns[0].header === undefined) {
      passedColumns.forEach((item) => {
        generatedColumns.push({
          Header: item,
          id: item,
          accessor: (d) => d[item],
          Cell: (props) => (
            <TextField
              style={{ width: '100%' }}
              InputProps={{ disableUnderline: true }}
              inputProps={{ style: { textAlign: 'center', width: '100%' } }}
              placeholder="Inserisci qui i dati..."
              disabled={!this.state.editMode}
              onBlur={this.aggiornaTabellaCustomHandler}
              defaultValue={props.row[item]}
              onInput={(event) => {
                let records = [...this.state.records];
                records.forEach((object, index) => {
                  if (index === props.row._index) {
                    records[index][item] = event.target.value;
                    const caret = event.target.selectionStart;
                    const element = event.target;
                    window.requestAnimationFrame(() => {
                      element.selectionStart = caret;
                      element.selectionEnd = caret;
                    });
                    this.setState({
                      records: records,
                    });
                  }
                });
              }}
            />
          ),
        });
      });
    } else {
      passedColumns.forEach((item) => {
        generatedColumns.push({
          Header: item.header,
          id: item.id,
          accessor: (d) => d[item.id],
          Cell: (props) => (
            <TextField
              defaultValue={props.row[item.id]}
              placeholder="Inserisci qui i dati..."
              disabled={!this.state.editMode}
              onBlur={this.aggiornaTabellaCustomHandler}
              style={{ width: '100%' }}
              InputProps={{ disableUnderline: true }}
              inputProps={{ min: 0, style: { textAlign: 'center' } }}
              onInput={(event) => {
                let records = [...this.state.records];
                records.forEach((object, index) => {
                  if (index === props.row._index) {
                    records[index][item.id] = event.target.value;
                    const caret = event.target.selectionStart;
                    const element = event.target;
                    window.requestAnimationFrame(() => {
                      element.selectionStart = caret;
                      element.selectionEnd = caret;
                    });
                    this.setState({
                      records: records,
                    });
                  }
                });
              }}
            />
          ),
        });
      });
    }
    generatedColumns.push({
      Header: 'Elimina',
      id: 'Elimina',
      accessor: (d) => d,
      width: 120,
      sortable: false,
      Cell: (props) => (
        <IconButton
          onClick={() => this.handleCustomTableRow(props.row)}
          style={{
            color: this.props.theme.palette.primary.main,
          }}
        >
          <DeleteForever />
        </IconButton>
      ),
    });
    return generatedColumns;
  };

  getColumnsForOrganigramma = () => {
    this.getOrganigrammaData();
    return [
      {
        Header: 'Nome e Cognome',
        id: 'NomeECognome',
        width: 300,
        accessor: (d) => d.NomeECognome,
        Cell: (props) => (
          <TextField
            onBlur={this.aggiornaOrganigrammaAfterInput}
            InputProps={{ disableUnderline: true }}
            inputProps={{ min: 0, style: { textAlign: 'center' } }}
            disabled={!this.state.editMode}
            value={props.row.NomeECognome}
            onChange={(event) => {
              props.row.NomeECognome = event.target.value;
              let OrganigrammaToChange = [...this.state.records];
              OrganigrammaToChange[props.index].NomeECognome =
                event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records: OrganigrammaToChange,
              });
            }}
            style={{
              width: '100%',
              textAlign: 'center',
              padding: 10,
              outline: `0 solid transparent`,
            }}
          />
        ),
      },
      {
        Header: 'Ruolo',
        id: 'Ruolo',
        width: this.state.rowWidth.toString + '%',
        accessor: (d) => d.Ruolo,
        Cell: (props) => (
          <TextField
            onBlur={this.aggiornaOrganigrammaAfterInput}
            InputProps={{ disableUnderline: true }}
            inputProps={{ style: { textAlign: 'center' } }}
            disabled={!this.state.editMode}
            value={props.row.Ruolo}
            onChange={(event) => {
              props.row.Ruolo = event.target.value;
              let OrganigrammaToChange = [...this.state.records];
              OrganigrammaToChange[props.index].Ruolo = event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records: OrganigrammaToChange,
              });
            }}
            style={{
              width: '100%',
              textAlign: 'center',
              padding: 10,
              outline: `0 solid transparent`,
            }}
          />
        ),
      },
      {
        Header: 'Mansione',
        id: 'Mansione',
        width: this.state.rowWidth.toString + '%',
        accessor: (d) => d.Mansione,
        Cell: (props) => (
          <TextField
            onBlur={this.aggiornaOrganigrammaAfterInput}
            InputProps={{ disableUnderline: true }}
            inputProps={{ style: { textAlign: 'center' } }}
            disabled={!this.state.editMode}
            value={props.row.Mansione}
            onChange={(event) => {
              props.row.Mansione = event.target.value;
              let OrganigrammaToChange = [...this.state.records];
              OrganigrammaToChange[props.index].Mansione = event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records: OrganigrammaToChange,
              });
            }}
            style={{
              width: '100%',
              textAlign: 'center',
              padding: 10,
              outline: `0 solid transparent`,
            }}
          />
        ),
      },
      {
        Header: 'Identificativo',
        id: 'Identificativo',
        width: 210,
        accessor: (d) => d.Identificativo,
        Cell: (props) => (
          <TextField
            onBlur={this.aggiornaOrganigrammaAfterInput}
            InputProps={{ disableUnderline: true }}
            inputProps={{ style: { textAlign: 'center' } }}
            disabled={!this.state.editMode}
            value={props.row.Identificativo}
            onChange={(event) => {
              props.row.Identificativo = event.target.value;
              let OrganigrammaToChange = [...this.state.records];
              OrganigrammaToChange[props.index].Identificativo =
                event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records: OrganigrammaToChange,
              });
            }}
            style={{
              width: '100%',
              textAlign: 'center',
              padding: 10,
              outline: `0 solid transparent`,
            }}
          />
        ),
      },
      {
        Header: 'Sposta',
        id: 'SpostaOrganigramma',
        width: 90,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementUpwardOrganigramma(props);
              }}
            >
              <KeyboardArrowUp />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementDownWardOrganigramma(props);
              }}
            >
              <KeyboardArrowDown />
            </IconButton>
          </div>
        ),
      },
      {
        Header: 'Elimina',
        id: 'EliminaOrganigramma',
        width: 120,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            onClick={() => this.deleteElementOrganigramma(props)}
            style={{
              margin: 5,
              color: this.props.theme.palette.primary.main,
            }}
          >
            <DeleteForever />
          </IconButton>
        ),
      },
    ];
  };

  getOrganigrammaData = () => {
    getContenutoParagrafo(this.props.idParagrafo)
      .then((result) => {
        const arrayOfRecords = [];
        result.componenti.forEach((item) => {
          if (item.componenti[0].organigramma) {
            let organigrammaData = JSON.parse(item.componenti[0].contenuto);
            if (organigrammaData.rows.length > 0) {
              organigrammaData.rows.forEach((row) => {
                arrayOfRecords.push({
                  NomeECognome: row[0],
                  Ruolo: row[1],
                  Mansione: row[2],
                  Identificativo: row[3],
                });
              });
            }
          }
        });
        this.setState({
          records: arrayOfRecords,
          firstRender: false,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  getSchedeHCCP = () => {
    getContenutoParagrafo(this.props.idParagrafo)
      .then((result) => {
        const recordsToSave = [];
        this.setState({
          dataToPassForProcedure: result.componenti,
        });

        const tabellaProcedure = result.componenti.find(
          (item) => item.tipoContenuto === 'TABELLA_PROCEDURE',
        );

        if (tabellaProcedure?.componenti?.length > 0) {
          tabellaProcedure.componenti.forEach((item) => {
            let objectToSave = {};
            if (item.tipo === 'PROCEDURA_HACCP') {
              objectToSave = {
                titolo: item.titolo,
                isScheda: false,
                isProceduraHaccp: true,
                id: item.id,
                idParagrafo: item.paragrafoId,
              };
            } else if (item.tipo === 'SCHEDA') {
              objectToSave = {
                titolo: item.titolo,
                isScheda: true,
                isProceduraHaccp: false,
                id: item.id,
                idParagrafo: item.paragrafoId,
              };
            }
            recordsToSave.push(objectToSave);
          });
        }

        this.setState({
          records: recordsToSave,
          firstRender: false,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  getRepartiData = () => {
    getReparti(this.props.idManuale, 0, 100, 'id')
      .then((result) => {
        let arrayToSave = [];
        result.forEach((item) => {
          let arrayResponsabiliToSave = [];
          item.responsabili.forEach((ids) => {
            arrayResponsabiliToSave.push(ids.id);
          });
          arrayToSave.push({
            id: item.id,
            manualeId: item.manualeId,
            nome: item.nome,
            repartoDefault: item.repartoDefault,
            responsabileSicurezzaId: item.responsabileSicurezzaId,
            responsabileSicurezzaEmail: item.responsabileSicurezzaEmail,
            responsabileSicurezzaNome: item.responsabileSicurezzaNome,
            responsabileSicurezzaCognome: item.responsabileSicurezzaCognome,
            responsabili: arrayResponsabiliToSave,
          });
        });
        this.setState(
          {
            records: arrayToSave,
            selectedReparto: result[0],
            firstElement: result[0],
          },
          () => {
            this.props.aggiornaReparti(arrayToSave);
          },
        );
      })
      .then((result) => {
        this.fetchResponsabiliSicurezza(this.props.idManuale);
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  getColumnsForDefinizioneReparto = () => {
    if (this.state.firstRender) {
      getReparti(this.props.idManuale, 0, 100, 'id')
        .then((result) => {
          let arrayToSave = [];
          result.forEach((item) => {
            let arrayResponsabiliToSave = [];
            item.responsabili.forEach((ids) => {
              arrayResponsabiliToSave.push(ids.id);
            });
            arrayToSave.push({
              id: item.id,
              manualeId: item.manualeId,
              nome: item.nome,
              repartoDefault: item.repartoDefault,
              responsabileSicurezzaId: item.responsabileSicurezzaId,
              responsabileSicurezzaEmail: item.responsabileSicurezzaEmail,
              responsabileSicurezzaNome: item.responsabileSicurezzaNome,
              responsabileSicurezzaCognome: item.responsabileSicurezzaCognome,
              responsabili: arrayResponsabiliToSave,
            });
          });
          this.setState({
            records: arrayToSave,
            selectedReparto: result[0],
            firstElement: result[0],
            firstRender: false,
          });
        })
        .then((result) => {
          this.fetchResponsabiliSicurezza(this.props.idManuale);
        })
        .catch((error) => {
          reportApiError(error);
        });
    }
    return [
      {
        Header: 'Reparto',
        id: 'Reparto',
        width: this.state.rowWidth.toString + '%',
        accessor: (d) => d.nome,
        Cell: (props) => (
          <TextField
            onBlur={() =>
              this.props.aggiornaReparti(this.state.records, props.row._index)
            }
            InputProps={{ disableUnderline: true }}
            inputProps={{ style: { textAlign: 'center' } }}
            disabled={!this.state.editMode}
            value={props.row.Reparto}
            onChange={(event) => {
              props.row.Reparto = event.target.value;
              let repartiToChange = [...this.state.records];
              repartiToChange[props.index].nome = event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records: repartiToChange,
              });
            }}
            style={{
              width: '100%',
              textAlign: 'center',
              padding: 10,
              outline: `0 solid transparent`,
            }}
          />
        ),
      },
      {
        Header: 'Email Utenza',
        id: 'EmailUtente',
        width: this.state.rowWidth.toString + '%',
        accessor: (d) => d,
        Cell: (props) => (
          <TextField
            InputProps={{ disableUnderline: true }}
            inputProps={{ style: { textAlign: 'center' } }}
            disabled
            style={{
              padding: 10,
              width: '100%',
              outline: `0 solid transparent`,
            }}
            value={
              props.row.EmailUtente.responsabili !== undefined
                ? this.getResponsabiliMailFromId(
                    props.row.EmailUtente.responsabili,
                  )
                : null
            }
          />
        ),
      },
      {
        Header: 'Associa Utenza',
        id: 'AssociaUtente',
        width: 200,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            disabled={this.state.isModello}
            onClick={() =>
              this.onAssociaButtonClicked(props.value, props.index)
            }
            style={{
              marginTop: 5,
              color: this.state.isModello
                ? this.props.theme.palette.disabled.main
                : this.props.theme.palette.primary.main,
            }}
          >
            <PersonAdd />
          </IconButton>
        ),
      },
      {
        Header: 'Elimina',
        id: 'EliminaDefinizioneReparto',
        width: 120,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            disabled={props.value.repartoDefault}
            onClick={() => this.deleteElementReparto(props)}
            style={{
              margin: 5,
              color: props.value.repartoDefault
                ? this.props.theme.palette.disabled.main
                : this.props.theme.palette.primary.main,
            }}
            title="Elimina reparto"
          >
            <DeleteForever />
          </IconButton>
        ),
      },
    ];
  };

  getLocaliForTabella = () => {
    getTotaleLocali(this.props.idManuale)
      .then((totaleLocali) => {
        this.setState({
          totalPages: Math.ceil(totaleLocali / 10),
        });
        return getLocaliManuale(
          this.props.idManuale,
          0,
          100000,
          'indiceOrdinamento',
        );
      })
      .then((locali) => {
        return getReparti(this.props.idManuale, 0, 100, 'id').then(
          (reparti) => {
            locali.forEach((item) => {
              item.repartiToSelect = reparti;
            });
            this.setState({
              records: locali,
              aggiuntaButtonDisabler: false,
            });
          },
        );
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  getColumnsForDescrizioneReparti = () => {
    this.getLocaliForTabella();
    return [
      {
        Header: 'Reparti',
        id: 'RepartiDescrizione',
        minWidth: 180,
        accessor: (d) => {
          const list = d.repartiToSelect || [];
          const selectedId = d.repartoId ?? '';
          const rep = Array.isArray(list)
            ? list.find((x) => x.id === selectedId)
            : null;
          return rep ? rep.nome : '';
        },
        Cell: (props) => (
          <>
            {props.original.repartiToSelect !== undefined ? (
              <Select
                disabled={
                  !(
                    !this.state.isBlocked ||
                    localStorage.getItem('superconsulente') === 'true' ||
                    localStorage.getItem('consulenteId') === 'null'
                  )
                }
                variant="outlined"
                onChange={(event) => {
                  const localiToChange = [...this.state.records];
                  localiToChange[props.index].repartoId = event.target.value;
                  localiToChange[props.index].nomeReparto =
                    this.getNomeRepartoFromId(
                      props.original.repartiToSelect,
                      event.target.value,
                    );
                  this.setState(
                    {
                      records: localiToChange,
                    },
                    () => {
                      this.aggiornaLocali();
                    },
                  );
                }}
                value={props.original.repartoId}
                style={{ paddingTop: 0, width: '100%' }}
              >
                {props.original.repartiToSelect !== undefined
                  ? props.original.repartiToSelect.map((item, index) => (
                      <MenuItem key={index} value={item.id} onClick={() => {}}>
                        {item.nome}
                      </MenuItem>
                    ))
                  : null}
              </Select>
            ) : (
              <Select></Select>
            )}
          </>
        ),
      },
      {
        Header: 'Locale',
        id: 'Locale',
        minWidth: 240,
        accessor: (d) => d.nome,
        Cell: (props) => (
          <TextField
            InputProps={{ disableUnderline: true }}
            onBlur={this.aggiornaLocali}
            value={props.row.Locale}
            onChange={(event) => {
              props.row.Locale = event.target.value;
              let LocaliToChange = [...this.state.records];
              LocaliToChange[props.index].nome = event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records: LocaliToChange,
              });
            }}
            inputProps={{ style: { textAlign: 'center' } }}
            disabled={!this.state.editMode}
            style={{
              textAlign: 'center',
              padding: 10,
              width: '100%',
              outline: `0 solid transparent`,
            }}
          />
        ),
      },
      {
        Header: 'Dimensioni',
        id: 'Dimensioni',
        width: 180,
        accessor: (d) => d.dimensione,
        Cell: (props) => (
          <TextField
            onBlur={this.aggiornaLocali}
            onChange={(event) => {
              const value = event.target.value.replace(/\D/g, '');

              props.row.Dimensioni = value;
              let dimensioniToChange = [...this.state.records];
              dimensioniToChange[props.index].dimensione = value;

              this.setState({
                records: dimensioniToChange,
              });
            }}
            InputProps={{ disableUnderline: true }}
            inputProps={{ min: 0, style: { textAlign: 'center' } }}
            disabled={!this.state.editMode}
            style={{
              textAlign: 'center',
              padding: 10,
              outline: `0 solid transparent`,
            }}
            value={props.row.Dimensioni}
          />
        ),
      },
      {
        Header: 'Attrezzature',
        id: 'Attrezzature',
        width: 180,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            onClick={() =>
              this.onAttrezzaturaButtonClicked(props.row.Attrezzature)
            }
          >
            <Build color="primary" />
          </IconButton>
        ),
      },
      {
        Header: 'Sposta',
        id: 'SpostaDescrizioneReparto',
        width: 150,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementUpwardLocali(props);
              }}
            >
              <KeyboardArrowUp />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementDownWardLocali(props);
              }}
            >
              <KeyboardArrowDown />
            </IconButton>
          </div>
        ),
      },
      {
        Header: 'Elimina',
        id: 'EliminaDescrizioneReparto',
        width: 120,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <IconButton
            onClick={() => this.deleteElementDescrizioneReparto(props)}
            style={{
              margin: 5,
              color: this.props.theme.palette.primary.main,
            }}
          >
            <DeleteForever />
          </IconButton>
        ),
      },
    ];
  };

  getColumnsForElencoProcedureAutocontrollo = () => {
    this.getSchedeHCCP();
    return [
      {
        Header: 'Titolo',
        id: 'TitoloProcedureAutocontrollo',
        width: this.state.rowWidth.toString + '%',
        accessor: (d) => d.titolo,
        Cell: (props) => (
          <TextField
            disabled={!this.state.editMode}
            InputProps={{ disableUnderline: true }}
            style={{
              textAlign: 'center',
              width: '100%',
              padding: 10,
              outline: `0 solid transparent`,
            }}
            inputProps={{ style: { textAlign: 'center' } }}
            value={props.row.TitoloProcedureAutocontrollo}
            //onBlur={() => this.aggiornaDefinizioneProcedureAutocontrollo()}
            onChange={(event) => {
              let newValues = [...this.state.records];
              newValues[props.index].titolo = event.target.value;
              const caret = event.target.selectionStart;
              const element = event.target;
              window.requestAnimationFrame(() => {
                element.selectionStart = caret;
                element.selectionEnd = caret;
              });
              this.setState({
                records: newValues,
              });
              let dataToPass = this.state.dataToPassForProcedure;
              var item = dataToPass[1].componenti.findIndex(
                (item) => newValues[props.index].id === item.id,
              );
              dataToPass[1].componenti[item].titolo = event.target.value;
              this.setState({
                dataToPassForProcedure: dataToPass,
              });
              this.props.bringTextToParent(
                dataToPass,
                this.state.indexTab,
                props.row._index,
              );
            }}
          />
        ),
      },
      {
        Header: 'Controllo',
        id: 'ControlloProcedureAutocontrollo',
        width: 130,
        accessor: (d) => d,
        Cell: (props) => (
          <Checkbox
            disabled
            checked={props.row.ControlloProcedureAutocontrollo.isProceduraHaccp}
          />
        ),
      },
      {
        Header: 'Scheda',
        id: 'SchedaProcedureAutocontrollo',
        width: 130,
        accessor: (d) => d,
        Cell: (props) => (
          <Checkbox
            disabled
            checked={props.row.SchedaProcedureAutocontrollo.isScheda}
          />
        ),
      },
      {
        Header: 'Modifica',
        id: 'ModificaProcedureAutocontrollo',
        width: 100,
        sortable: false,
        accessor: (d) => d,
        Cell: (
          props, //<ActionButton onClick = {() => console.log(props.row.ModificaProcedureAutocontrollo)}></ActionButton>
        ) =>
          props.row.ModificaProcedureAutocontrollo.isScheda ? (
            <GoToIcon
              mode="Scheda"
              idManuale={this.props.idManuale}
              id={props.row.ModificaProcedureAutocontrollo.id}
              idParagrafo={props.row.ModificaProcedureAutocontrollo.idParagrafo}
            />
          ) : props.row.ModificaProcedureAutocontrollo.isProceduraHaccp ? (
            <GoToIcon
              mode="Procedura"
              idManuale={this.props.idManuale}
              id={props.row.ModificaProcedureAutocontrollo.id}
              idParagrafo={props.row.ModificaProcedureAutocontrollo.idParagrafo}
            />
          ) : (
            <ActionButton onClick={() => console.log('')} />
          ),
      },
      {
        Header: 'Sposta',
        id: 'SpostaProcedureAutocontrollo',
        width: 100,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              flex: 1,
            }}
          >
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementUpwardAutocontrolli(props);
              }}
            >
              <KeyboardArrowUp />
            </IconButton>
            <IconButton
              size="small"
              onClick={() => {
                this.moveElementDownWardAutocontrolli(props);
              }}
            >
              <KeyboardArrowDown />
            </IconButton>
          </div>
        ),
      },
      {
        Header: 'Elimina',
        id: 'EliminaProcedureAutocontrollo',
        width: 120,
        sortable: false,
        accessor: (d) => d,
        Cell: (props) => (
          <>
            <IconButton
              onClick={() => this.deleteProcedureAutocontrollo(props)}
              style={{
                color: this.props.theme.palette.primary.main,
              }}
              title="Elimina procedura"
            >
              <DeleteForever />
            </IconButton>
          </>
        ),
      },
    ];
  };

  deleteProcedureAutocontrollo = (cellInfo) => {
    const isAdmin = localStorage.getItem('consulenteId') === 'null';
    const isSuperConsulente =
      localStorage.getItem('superconsulente') === 'true';
    const canDelete = !this.state.isBlocked || isAdmin || isSuperConsulente;

    if (!canDelete) {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
      return;
    }

    this.setState({
      confirmRemoveProcedura: { open: true, rowIndex: cellInfo.index },
    });
  };

  handleConfirmRemoveProcedura = () => {
    this.setState({ deletingProcedura: true });

    let array = Array.from(this.state.records);
    array.splice(this.state.confirmRemoveProcedura.rowIndex, 1);
    let itemToPass = this.state.dataToPassForProcedure[1].componenti;
    let dataToPassForSottoparagrafi = this.state.dataToPassForProcedure;
    itemToPass.splice(this.state.confirmRemoveProcedura.rowIndex, 1);
    dataToPassForSottoparagrafi[1].componenti = itemToPass;

    const bodyToPassForSottoparagrafi = {
      id: this.props.idParagrafo,
      manualeId: this.props.idManuale,
      titolo: 'Definizione procedure autocontrollo',
      componenti: dataToPassForSottoparagrafi,
    };
    updateSottoparagrafi(bodyToPassForSottoparagrafi)
      .then((result) => {
        this.getSchedeHCCP();
        this.props.bringDataToParent(
          bodyToPassForSottoparagrafi,
          this.state.indexTab,
        );
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => {
        this.setState({
          deletingProcedura: false,
          confirmRemoveProcedura: { open: false, rowIndex: null },
        });
      });
  };

  handleCancelRemoveProcedura = () => {
    this.setState({ confirmRemoveProcedura: { open: false, rowIndex: null } });
  };

  deleteElementReparto = (cellInfo) => {
    const isAdmin = localStorage.getItem('consulenteId') === 'null';
    const isSuperConsulente =
      localStorage.getItem('superconsulente') === 'true';
    const canDelete = !this.state.isBlocked || isAdmin || isSuperConsulente;

    if (!canDelete) {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
      return;
    }

    this.setState({
      confirmRemoveReparto: { open: true, rowIndex: cellInfo.index },
    });
  };

  handleConfirmRemoveReparto = () => {
    const rowIndex = this.state.confirmRemoveReparto.rowIndex;

    const updatedReparti = this.state.records.filter((_, i) => i !== rowIndex);

    this.setState({ deletingReparto: true });
    updateReparti(this.props.idManuale, updatedReparti)
      .then(() => {
        this.getRepartiData(); // ricarico per avere dati allineati dal server (id, ordinamenti, ecc.)
        this.props.aggiornaReparti(updatedReparti); // mantengo anche il parent in sync
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => {
        this.setState({
          deletingReparto: false,
          confirmRemoveReparto: { open: false, rowIndex: null },
        });
      });
  };

  handleCancelRemoveReparto = () => {
    this.setState({
      confirmRemoveReparto: { open: false, rowIndex: null },
    });
  };

  deleteElementOrganigramma = (cellInfo) => {
    const isSuperConsulente =
      localStorage.getItem('superconsulente') === 'true';
    const isAdmin = localStorage.getItem('consulenteId') === 'null';

    const canDelete = !this.state.isBlocked || isAdmin || isSuperConsulente;

    if (!canDelete) {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
      return;
    }

    let array = Array.from(this.state.records);
    array.splice(cellInfo.index, 1);
    this.setState({ records: array });

    const rows = array.map((item) => [
      item.NomeECognome,
      item.Ruolo,
      item.Mansione,
      item.Identificativo,
    ]);

    const updatedContenuto = {
      columns: ['Nome e cognome', 'Ruolo', 'Mansione', 'Identificativo'],
      rows,
    };

    let dataToPass = [...this.props.sottoParagrafiData];
    dataToPass.forEach((item) => {
      if (item.componenti[0].organigramma) {
        item.componenti[0].contenuto = JSON.stringify(updatedContenuto);
      }
    });
  };

  deleteElementDescrizioneReparto = (cellInfo) => {
    const isAdmin = localStorage.getItem('consulenteId') === 'null';
    const isSuperConsulente =
      localStorage.getItem('superconsulente') === 'true';
    const canDelete = !this.state.isBlocked || isAdmin || isSuperConsulente;

    if (!canDelete) {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
      return;
    }

    this.setState({
      confirmRemoveLocale: { open: true, rowIndex: cellInfo.index },
    });
  };

  handleConfirmRemoveLocale = () => {
    const rowIndex = this.state.confirmRemoveLocale.rowIndex;

    let updated = this.state.records
      .filter((_, i) => i !== rowIndex)
      .map((l, i) => ({ ...l, indiceOrdinamento: i }));

    this.setState({ deletingLocale: true });

    const body = {
      manualeId: this.props.idManuale,
      locali: updated,
    };

    updateLocaliManuale(body)
      .then(() => {
        this.getLocaliForTabella();
        this.props.aggiornaLocali(updated);
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => {
        this.setState({
          deletingLocale: false,
          confirmRemoveLocale: { open: false, rowIndex: null },
        });
      });

    let array = Array.from(this.state.records);
    array.splice(rowIndex, 1);
    this.setState(
      {
        records: array,
        confirmRemoveLocale: { open: false, rowIndex: null },
      },
      () => {
        this.aggiornaLocali();
      },
    );
  };

  handleCancelRemoveLocale = () => {
    this.setState({
      confirmRemoveLocale: { open: false, rowIndex: null },
    });
  };

  handleNewRow = () => {
    const isAdmin = localStorage.getItem('consulenteId') === 'null';
    const isSuperConsulente =
      localStorage.getItem('superconsulente') === 'true';
    const canAdd = !this.state.isBlocked || isAdmin || isSuperConsulente;
    if (!canAdd) {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
      return;
    }

    let newRowRecords = Array.from(this.state.records);

    if (this.props.mode === 'Definizione_Reparto') {
      const newReparto = {
        id: null,
        manualeId: this.state.records[0].manualeId,
        nome: 'Nuovo reparto',
        repartoDefault: false,
        responsabileSicurezzaCognome: null,
        responsabileSicurezzaEmail: null,
        responsabileSicurezzaId: null,
        responsabileSicurezzaNome: null,
        responsabili: [],
      };
      newRowRecords.push(newReparto);

      // Show the new row immediately; getRepartiData() below replaces it
      // with the server copy once updateReparti has assigned real ids.
      this.setState({ records: newRowRecords }, () => {
        this.props.aggiornaReparti(newRowRecords);
      });

      updateReparti(this.props.idManuale, newRowRecords)
        .then(() => this.getRepartiData()) // refetch per id aggiornati
        .catch((error) => {
          reportApiError(error);
          // ripristina lo stato da server in caso di errore
          this.getRepartiData();
        });
      return;
    } else if (this.props.mode === 'Organigramma') {
      let records = [...this.state.records];
      let objectToAdd = {
        NomeECognome: '',
        Ruolo: '',
        Mansione: '',
        Identificativo: '',
      };
      records.push(objectToAdd);
      this.setState({
        records: records,
      });
      let newOrganigrammaRecord = [...this.state.records];
      newOrganigrammaRecord.push(objectToAdd);
      let dataToPass = [...this.props.sottoParagrafiData];
      let object = JSON.parse(
        dataToPass[this.state.indexTab].componenti[0].contenuto,
      );
      let objToPassToSave = {
        columns: ['Nome e cognome', 'Ruolo', 'Mansione', 'Identificativo'],
        rows: [...object.rows, ['', '', '', '']],
      };
      dataToPass.forEach((item) => {
        if (item.componenti[0].organigramma) {
          item.componenti[0].contenuto = JSON.stringify(objToPassToSave);
        }
      });
    } else if (this.props.mode === 'Descrizione_Reparto') {
      this.setState({
        aggiuntaButtonDisabler: true,
      });
      getReparti(this.props.idManuale, 0, 100, 'id')
        .then((result) => {
          let objToAppend = {
            id: null,
            manualeId: this.props.idManuale,
            repartoId: result[0].id,
            nome: 'Nuovo Locale',
            dimensione: 0,
            indiceOrdinamento: 0,
          };
          newRowRecords.push(objToAppend);
          let body = {
            manualeId: this.props.idManuale,
            locali: newRowRecords,
          };
          return updateLocaliManuale(body).then((result) => {
            this.getLocaliForTabella();
          });
        })
        .catch((error) => {
          reportApiError(error);
          this.setState({
            aggiuntaButtonDisabler: false,
          });
        });
    } else if (this.props.mode === 'Definizione_Procedure_Autocontrollo') {
      this.setState({
        selectProcedureAutocontrolloModalOpen: true,
      });
    } else {
      let columnsOfTable = [...this.state.columns];
      let rowsOfTable = [...this.state.records];
      let newObject = {};
      columnsOfTable.forEach((item) => {
        newObject['' + item.id] = '';
      });
      rowsOfTable.push(newObject);
      this.setState({
        records: rowsOfTable,
      });
    }
  };

  handleNewRowProcedureAutocontrollo = (tipologia) => {
    const isAdmin = localStorage.getItem('consulenteId') === 'null';
    const isSuperConsulente =
      localStorage.getItem('superconsulente') === 'true';

    const canAdd = !this.state.isBlocked || isAdmin || isSuperConsulente;

    if (!canAdd) {
      alert(
        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
      );
      return;
    }

    const sottoparagrafo = this.state.dataToPassForProcedure.find(
      (item) => item.tipoContenuto === 'TABELLA_PROCEDURE',
    );
    const sottoparagrafoIdToPass = sottoparagrafo?.id || null;

    const tipo = tipologia === 'Scheda' ? 'SCHEDA' : 'PROCEDURA_HACCP';
    const objToPass = {
      tipo,
      id: null,
      paragrafoId: this.props.idParagrafo,
      parentComponentId: sottoparagrafoIdToPass,
      titolo: 'Nuova Procedura',
    };

    this.setState({
      selectProcedureAutocontrolloModalOpen: false,
    });
    this.aggiungiDefinizioneProcedureAutocontrollo(objToPass);
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainContainer}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <div style={{ display: 'flex' }}>
              <TextField
                InputProps={{ disableUnderline: true, style: { fontSize: 30 } }}
                multiline
                inputProps={{
                  min: 0,
                  style: { /* textAlign: "center" */ width: '15em' },
                }}
                InputLabelProps={{ style: { fontSize: 30 } }}
                disabled={!this.state.isTitleEditable}
                onInput={(e) => {
                  this.setState({
                    titoloInizialeSottoparagrafo: e.target.value,
                  });
                }}
                onBlur={() => {
                  this.props.bringTitleToParent(
                    this.state.titoloInizialeSottoparagrafo,
                    this.props.indexTab,
                  );
                }}
                value={this.state.titoloInizialeSottoparagrafo}
              />
            </div>
          </div>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              height: '4em',
              gap: '16px',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              {(!this.props.firstElement ||
                this.props.mode === 'Definizione_Procedure_Autocontrollo') && (
                <IconButton
                  onClick={() => {
                    if (
                      !this.state.isBlocked ||
                      localStorage.getItem('superconsulente') === 'true' ||
                      localStorage.getItem('consulenteId') === 'null'
                    ) {
                      this.setState((prevState) => ({
                        isTitleEditable: !prevState.isTitleEditable,
                      }));
                    } else {
                      alert(
                        'Attenzione, operazione non permessa poichè il paragrafo è bloccato',
                      );
                    }
                  }}
                >
                  <Edit
                    htmlColor={
                      this.state.isTitleEditable
                        ? this.props.theme.palette.primary.main
                        : '#707070'
                    }
                  />
                </IconButton>
              )}
              {!this.props.firstElement && (
                <IconButton
                  onClick={() => {
                    this.props.handleRimuoviTabella(this.props.indexTab);
                  }}
                >
                  <CloseIcon />
                </IconButton>
              )}
              {!this.props.firstElement && (
                <IconButton
                  size="small"
                  disabled={
                    this.props.sottoParagrafiData[this.props.indexTab - 1]
                      .tipoContenuto === 'TABELLA_PROCEDURE'
                  }
                  onClick={() => {
                    this.props.moveUpward(this.props.indexTab);
                  }}
                >
                  <ArrowUpward />
                </IconButton>
              )}
              {!this.props.firstElement && (
                <IconButton
                  size="small"
                  onClick={() => {
                    this.props.moveDownward(this.props.indexTab);
                  }}
                >
                  <ArrowDownward />
                </IconButton>
              )}
            </div>
            <div className={classes.topButtonWrapper}>
              <IconButton
                color="primary"
                size="small"
                title="Aggiungi"
                aria-label="Aggiungi"
                onClick={this.handleNewRow}
              >
                <Add />
              </IconButton>
              <Button
                variant="contained"
                onClick={() => {
                  if (
                    !this.state.isBlocked ||
                    localStorage.getItem('superconsulente') === 'true' ||
                    localStorage.getItem('consulenteId') === 'null'
                  ) {
                    this.setState((prevState) => ({
                      editMode: !prevState.editMode,
                    }));
                  } else {
                    alert(
                      'Attenzione, operazione non permessa perchè il paragrafo è bloccato',
                    );
                  }
                }}
                style={{
                  color: this.state.editMode
                    ? 'white'
                    : this.props.theme.palette.text.main,
                  margin: '10px',
                  backgroundColor: this.state.editMode
                    ? 'green'
                    : this.props.theme.palette.primary.main,
                  width: 100,
                }}
              >
                {this.state.editMode ? (
                  <>
                    <Done fontSize="small" style={{ marginRight: 5 }} />
                    Done
                  </>
                ) : (
                  <>
                    <Edit fontSize="small" style={{ marginRight: 14 }} />
                    Edit
                  </>
                )}
              </Button>
            </div>
          </div>
        </div>
        <div style={{ fontSize: 25 }}>{this.state.title}</div>
        <div style={{ width: '100%' }}>
          <ReactTable
            className="manuale-react-table"
            key={this.state.tableKey}
            filterable={false}
            resizable={true}
            enableEditing={true}
            showPageSizeOptions={false}
            showPageJump={true}
            defaultPageSize={10}
            style={{
              height: 400,
              width: '100%',
            }}
            //pages={this.state.pages}
            data={this.state.records}
            columns={this.state.columns}
            //manual // informs React Table that you'll be handling sorting and pagination server-side
            //onFetchData={ (state, instance) => { this.fetchData(state.page, state.pageSize) } }
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun record"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
            getTrProps={(state, rowInfo) => {
              if (!rowInfo) return {};

              return {
                key: rowInfo.original.id || rowInfo.index, // assegna key stabile
              };
            }}
          />
        </div>
        {this.state.openModalResponsabili && (
          <ModalResponsabiliPerReparto
            open={this.state.openModalResponsabili}
            onClose={this.onCloseModalResponsabili}
            onSubmit={this.onResponsabiliSelected}
            reparto={this.state.selectedReparto}
            responsabiliEsercizio={this.state.responsabiliSicurezza}
          />
        )}
        {this.state.openModalAttrezzatura && (
          <ModalSelezioneAttrezzatura
            theme={this.props.theme}
            manualeId={this.props.idManuale}
            open={this.state.openModalAttrezzatura}
            onClose={this.onCloseModalAttrezzatura}
            selectedLocale={this.state.selectedLocale}
          />
        )}
        {this.state.confirmRemoveReparto.open && (
          <DialogConfirmOperation
            open={this.state.confirmRemoveReparto.open}
            onCancel={this.handleCancelRemoveReparto}
            onConfirm={this.handleConfirmRemoveReparto}
            title="Conferma eliminazione reparto"
            description="Attenzione! Eliminando il reparto verranno rimosse anche le relative associazioni. Vuoi continuare?"
            cancelButtonLabel="Annulla"
            confirmButtonLabel="Conferma"
            loading={this.state.deletingReparto}
          />
        )}
        {this.state.confirmRemoveLocale.open && (
          <DialogConfirmOperation
            open={this.state.confirmRemoveLocale.open}
            onCancel={this.handleCancelRemoveLocale}
            onConfirm={this.handleConfirmRemoveLocale}
            title="Conferma eliminazione locale"
            description="Attenzione! Eliminando il locale si eliminineranno anche tutte le associazioni presenti nei controlli conformità. Vuoi continuare?"
            cancelButtonLabel="Annulla"
            confirmButtonLabel="Conferma"
            loading={this.state.deletingLocale}
          />
        )}
        {this.state.confirmRemoveProcedura.open && (
          <DialogConfirmOperation
            open={this.state.confirmRemoveProcedura.open}
            onCancel={this.handleCancelRemoveProcedura}
            onConfirm={this.handleConfirmRemoveProcedura}
            title="Conferma eliminazione procedura"
            description="Questa operazione rimuove la procedura dall’elenco. Vuoi continuare?"
            cancelButtonLabel="Annulla"
            confirmButtonLabel="Conferma"
            loading={this.state.deletingProcedura}
          />
        )}
        {this.state.selectProcedureAutocontrolloModalOpen && (
          <ModalSelezioneModalitaAutocontrollo
            open={this.state.selectProcedureAutocontrolloModalOpen}
            onClose={this.onCloseModalSelezioneModalitaAutocontrollo}
            handleNewRow={this.handleNewRowProcedureAutocontrollo}
          />
        )}
      </div>
    );
  }
}

CustomTableForManuale.propTypes = {
  aggiornaLocali: PropTypes.func,
  bringDataToParent: PropTypes.func,
  handleRimuoviTabella: PropTypes.func,
  idManuale: PropTypes.number.isRequired,
  isParagrafoBlocked: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withStyles(styles)(CustomTableForManuale);
